import {Amplify} from 'aws-amplify';

import log from '../logger/log';

const configure = (config) => {
    try {
        Amplify.configure(config);
        log.info('awsClient: Configured');
    } catch (e) {
        log.error('awsClient: configure error', e);
        throw e;
    }
};

const awsClient = {
    configure,
};

export default awsClient;
